import React from "react";

const Dashboard = React.lazy(() => import("./components/Dashboard"));
const Licensee = React.lazy(() => import("./containers/LicenseeContainer"));
const Login = React.lazy(() => import("./containers/LoginContainer"));
const Country = React.lazy(() => import("./containers/CountryContainer"));
const State = React.lazy(() => import("./containers/StateContainer"));
const District = React.lazy(() => import("./containers/DistrictContainer"));
const Currency = React.lazy(() => import("./containers/CurrencyContainer"));
const CountryCrncy = React.lazy(() =>
  import("./containers/CountryCrncyContainer")
);
const Unit = React.lazy(() => import("./containers/UnitContainer"));
const PaymentMode = React.lazy(() =>
  import("./containers/PaymentModeContainer")
);
const Brand = React.lazy(() => import("./containers/BrandContainer"));
const DistributorProfile = React.lazy(() =>
  import("./containers/DistributorProfileContainer")
);

const ForgotPassword = React.lazy(() =>
  import("./containers/FrgtPswdContainer")
);
//const SignUp = React.lazy(() => import("./containers/SignUpContainer"));
const Feedback = React.lazy(() => import("./containers/FeedbackContainer"));
const PatientsProfile = React.lazy(() =>
  import("./containers/PatientsProfileContainer")
);
const PatientPayment = React.lazy(() =>
  import("./containers/PatientPaymentContainer")
);
const PatientInvoice = React.lazy(() =>
  import("./containers/PatientInvoiceContainer")
);
const ChemistProfile = React.lazy(() =>
  import("./containers/ChemistProfileContainer")
);
const ChemistPayment = React.lazy(() =>
  import("./containers/ChemistPaymentContainer")
);
const ChemistInvoice = React.lazy(() =>
  import("./containers/ChemistInvoiceContainer")
);
const Appversion = React.lazy(() => import("./containers/AppversionContainer"));
const BatchAdmin = React.lazy(() => import("./screens/BatchAdmin/BatchAdmin"));

const Support = React.lazy(() => import("./containers/SupportContainer"));
const SupportUsers = React.lazy(() =>
  import("./containers/SupportUsersContainer")
);

const PatientsOrder = React.lazy(() =>
  import("./containers/PatientsOrderContainer")
);

const ChemistOrder = React.lazy(() =>
  import("./containers/ChemistOrderContainer")
);

const ProductReturns = React.lazy(() =>
  import("./containers/ProductReturnsContainer")
);
const CreditNotes = React.lazy(() =>
  import("./containers/CreditNotesContainer")
);
const PlatformEarnings = React.lazy(() => import("./screens/PlatformEarnings"));
const ItemMaster = React.lazy(() => import("./containers/ItemMasterContainer"));
const DeliveryStatus = React.lazy(() =>
  import("./containers/DeliveryStatusContainer")
);
const ItemCategory = React.lazy(() =>
  import("./containers/ItemCategoryContainer")
);
const SupportType = React.lazy(() =>
  import("./containers/SupportTypeContainer")
);
const AuditTrace = React.lazy(() => import("./containers/AuditTraceContainer"));

const TermsandCondition = React.lazy(() =>
  import("./containers/TermsandConditionContainer")
);
const Helpline = React.lazy(() => import("./containers/HelplineContainer"));
const Bank = React.lazy(() => import("./containers/BankContainer"));

const Cpvalue = React.lazy(() => import("./containers/CpvalueContainer"));

/*const location = React.lazy(() => import("./containers/LocationContainer"));
const Category = React.lazy(() => import("./containers/CategoryContainer"));
const Subcategory = React.lazy(() =>
  import("./containers/SubcategoryContainer")
);*/

const routes = [
  {
    path: "/",
    exact: true,
    name: "Home",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/licensee",
    name: "Licensee",
    component: Licensee,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/settings/country",
    name: "Countries",
    component: Country,
  },
  {
    path: "/settings/state",
    name: "State",
    component: State,
  },
  {
    path: "/settings/district",
    name: "Districts",
    component: District,
  },
  {
    path: "/settings/currency",
    name: "Currencies",
    component: Currency,
  },
  {
    path: "/settings/countryCrncy",
    name: "Country Currency",
    component: CountryCrncy,
  },
  {
    path: "/settings/paymentmode",
    name: "PaymentMode",
    component: PaymentMode,
  },
  {
    path: "/settings/itemCategory",
    name: "ItemCategory",
    component: ItemCategory,
  },
  {
    path: "/settings/deliveryStatus",
    name: "Delivery Status",
    component: DeliveryStatus,
  },
  {
    path: "/settings/unit",
    name: "Unit",
    component: Unit,
  },
  {
    path: "/settings/brand",
    name: "Brand",
    component: Brand,
  },
  {
    path: "/settings/Cpvalue",
    name: "CP Value",
    component: Cpvalue,
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: Feedback,
  },
  {
    path: "/chemistuser/chemistprofile",
    name: "Chemist Profiles",
    component: ChemistProfile,
  },
  {
    path: "/chemistuser/chemistPayment",
    name: "Chemist Payments",
    component: ChemistPayment,
  },
  {
    path: "/chemistuser/chemistInvoice",
    name: "Chemist Invoices",
    component: ChemistInvoice,
  },
  {
    path: "/patientusers/patientsprofile",
    name: "Patient Profiles",
    component: PatientsProfile,
  },
  {
    path: "/patientusers/patientPayment",
    name: "Patient Payments",
    component: PatientPayment,
  },
  {
    path: "/patientusers/patientInvoice",
    name: "Patient Invoices",
    component: PatientInvoice,
  },
  // {
  //   path: "/settings/subcategory",
  //   name: "Subcategory",
  //   component: Subcategory
  // },
  {
    path: "/forgotpassword",
    name: "Forgot Password",
    component: ForgotPassword,
  },
  {
    path: "/patientusers/patientorder",
    name: "Patient Orders",
    component: PatientsOrder,
  },
  {
    path: "/distributors",
    name: "Distributor",
    component: DistributorProfile,
  },
  {
    path: "/chemistuser/chemistorders",
    name: "Chemist Orders",
    component: ChemistOrder,
  },
  {
    path: "/productreturns",
    name: "Product Returns",
    component: ProductReturns,
  },
  {
    path: "/creditnotes",
    name: "Credit Notes",
    component: CreditNotes,
  },
  {
    path: "/platformearnings",
    name: "Platform Earnings",
    component: PlatformEarnings,
  },
  {
    path: "/auditTrace",
    name: "Audit Trace",
    component: AuditTrace,
  },
  {
    path: "/support",
    name: "Support",
    component: Support,
  },
  {
    path: "/supportUsers",
    name: "Support Users",
    component: SupportUsers,
  },
  {
    path: "/settings/supportType",
    name: "Support Types",
    component: SupportType,
  },
  {
    path: "/itemmaster",
    name: "Item Master",
    component: ItemMaster,
  },
  /* {
    path: "/signup",
    name: "SignUp",
    component: SignUp
  }, */
  {
    path: "/settings/termsandcondition",
    name: "Terms and Condition",
    component: TermsandCondition,
  },
  {
    path: "/settings/helpline",
    name: "Helpline",
    component: Helpline,
  },
  {
    path: "/settings/bank",
    name: "Bank",
    component: Bank,
  },
  {
    path: "/appversion",
    name: "App Version",
    component: Appversion,
  },
  {
    path: "/batchadmin",
    name: "Batch Admin",
    component: BatchAdmin,
  },
];

export default routes;
